import React from 'react';
import { useInView } from 'react-intersection-observer';
import { MapPin, Calendar } from 'lucide-react';
import { useSectionData } from '../hooks/useSectionData';
import { fetchExperiences, attr } from '../services/api';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

export default function Experience() {
  const items = useSectionData(fetchExperiences);
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="experience" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">experience</p>
          <h2 className="section-title">Professional Experience</h2>
          <div className="section-line" />
        </header>

        <div className="timeline">
          {items.map((item, i) => {
            const a = attr(item);
            const techs = Array.isArray(a.technologies) ? a.technologies : [];
            const start = formatDate(a.start_date);
            const end = a.is_current ? 'Present' : formatDate(a.end_date);

            return (
              <div key={i} className="timeline-item">
                <div className="timeline-header">
                  <div>
                    <p className="timeline-title">{a.title}</p>
                    <p className="timeline-org">{a.company}</p>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 6 }}>
                    {a.is_current && <span className="current-badge">Current</span>}
                    <span className="timeline-meta">
                      <Calendar size={12} />
                      {start} — {end}
                    </span>
                    {a.location && (
                      <span className="timeline-meta">
                        <MapPin size={12} /> {a.location}
                      </span>
                    )}
                  </div>
                </div>

                {a.description && (
                  <p className="timeline-body">{a.description}</p>
                )}

                {techs.length > 0 && (
                  <div className="timeline-tags">
                    {techs.map(t => <span key={t} className="badge">{t}</span>)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
